import { ReactElement, useMemo } from 'react';

import { pluralize } from '~utils/commons';

import { useDashboardVariantV2CarrierContext } from '../../../Context';
import {
  DashboardVariantV2CarrierZoneSaturationCollapseTableContainer,
  DashboardVariantV2CarrierZoneSaturationCollapseTableLoading,
  DashboardVariantV2CarrierZoneSaturationCollapseTableTitle,
} from './styles';
import DashboardVariantV2CarrierZoneSaturationCollapseTableContent from './Content';

const DashboardVariantV2CarrierZoneSaturationCollapseTable =
  (): ReactElement => {
    const {
      data: {
        zoneSaturation: {
          data: { totalDriversCount, totalCapacity },
          loading: loadingZoneSaturation,
        },
      },
    } = useDashboardVariantV2CarrierContext();

    const packagesPerDriver = useMemo(
      () =>
        totalDriversCount > 0
          ? Math.round(totalCapacity / totalDriversCount)
          : 0,
      [totalDriversCount, totalCapacity],
    );

    const title = useMemo(() => {
      const packagesPerDriverText = pluralize({
        singular: 'paquete',
        count: packagesPerDriver,
        includeCount: true,
      });

      return `En camino al depósito, en depósito y en tránsito sobre la
      capacidad de la zona · ${packagesPerDriverText} por chofer`;
    }, [packagesPerDriver]);

    return (
      <DashboardVariantV2CarrierZoneSaturationCollapseTableContainer>
        {loadingZoneSaturation && (
          <DashboardVariantV2CarrierZoneSaturationCollapseTableLoading />
        )}

        <DashboardVariantV2CarrierZoneSaturationCollapseTableTitle
          variant="caption"
          fontWeight="bold"
        >
          {title}
        </DashboardVariantV2CarrierZoneSaturationCollapseTableTitle>

        <DashboardVariantV2CarrierZoneSaturationCollapseTableContent />
      </DashboardVariantV2CarrierZoneSaturationCollapseTableContainer>
    );
  };

export default DashboardVariantV2CarrierZoneSaturationCollapseTable;
